import { render } from "./TurnPageButton.vue?vue&type=template&id=a34e60c8&scoped=true"
import script from "./TurnPageButton.vue?vue&type=script&lang=ts"
export * from "./TurnPageButton.vue?vue&type=script&lang=ts"

import "./TurnPageButton.vue?vue&type=style&index=0&id=a34e60c8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a34e60c8"

export default script